import { render, staticRenderFns } from "./CouponsTable.vue?vue&type=template&id=749b646e&scoped=true&"
import script from "./CouponsTable.vue?vue&type=script&lang=js&"
export * from "./CouponsTable.vue?vue&type=script&lang=js&"
import style0 from "./CouponsTable.vue?vue&type=style&index=0&id=749b646e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749b646e",
  null
  
)

export default component.exports